module.exports = __webpack_public_path__ + "img/Slice5-min.dc5a3e4b.png";